import React from "react";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Tooltip from "material-ui/Tooltip";
import Select from "material-ui/Select";
import Input from "material-ui/Input";
import { MenuItem } from "material-ui/Menu";
import { Link } from "react-router-dom";
import {
  FormControl,
  FormHelperText,
  FormControlLabel,
  FormGroup,
} from "material-ui/Form";
import Switch from "material-ui/Switch";
import ButtonBase from "material-ui/ButtonBase";
import { CircularProgress } from "material-ui/Progress";

import { withStyles } from "material-ui/styles";
import styles from "./styles";

import JobProgress from "./jobProgress";

import {
  dateFormatter,
  isVDVType,
  isSignalTEKQTType,
  isNaviTEKType,
} from "../../../common/utils";

const SMART_FLAG_NONE = "__none__";
const SMART_FLAG_CUSTOMER_DEFAULT = "__customer_default__";

class JobHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      errors: {},
      tabs: [
        props.translate("job_details"),
        props.translate("job_metadata"),
        props.translate("job_settings"),
      ],
      tabPosition: 0,
      job: {
        publish: false,
        status: false,
        enablesync: true,
        enableJobComplete: false,
        name: "",
        deviceid: props.prevSelectedDeviceid ? props.prevSelectedDeviceid : "",
        customerid: "",
        metadatalookupid: "",
        metadataStandardCustom: {
          6: { enabled: false, value: "" },
          5: { enabled: false, value: "" },
          4: { enabled: false, value: "" },
          3: { enabled: false, value: "" },
          2: { enabled: false, value: "" },
          1: { enabled: false, value: "" },
        },
      },
      customer: {
        name: "",
        address: "",
        contactemail: "",
        telephoneno: "",
        contact: "",
        city: "",
        state: "",
        country: "",
        zipcode: "",
      },
      mode: "create",
      showDeviceTypes: true,
      disableJobIdentifiers: false,
    };
  }

  onToggleChange = (e, checked, job) => {
    if (job.deviceid) {
      job[e.target.name] = checked;
      this.setState({ job: job });
      this.props.onSyncChange(job.id);
    }
  };

  getSmartFlagProfileSourceMessage = (source) => {
    switch (source) {
      case "job":
        return "Linked directly to this job Smart Flag profile.";
      case "customer":
        return "Linked from the customer Smart Flag profile.";
      case "parentCustomer":
        return "Inherited from the parent customer Smart Flag profile.";
      default:
        return "Smart Flag Profile can be assigned at the customer level or job level.";
    }
  };

  renderSmartFlagProfile() {
    const {
      classes,
      job,
      translate,
      onEditSmartFlagProfile,
      onSmartFlagProfileChange,
      smartFlagProfiles,
    } = this.props;

    if (!job) {
      return null;
    }

    const hasEffectiveProfile = !!job.effectiveSmartFlagProfileId;
    const profileName =
      job.effectiveSmartFlagProfileName || "Smart Flag Profile not assigned";
    const directProfileId = job.smartFlagProfileId || "";
    const sourceMessage = this.getSmartFlagProfileSourceMessage(
      job.effectiveSmartFlagProfileSource,
    );
    const profiles = smartFlagProfiles || [];
    const customerDefaultId = job.customerSmartFlagProfileId;
    const defaultProfileIds = [customerDefaultId]
      .filter(Boolean)
      .map((id) => String(id));
    const getProfileName = (profileId, fallbackName) => {
      const profile = profiles.find(
        (item) => String(item.id) === String(profileId),
      );
      return profile ? profile.name : fallbackName;
    };
    const customerDefaultName = customerDefaultId
      ? getProfileName(customerDefaultId, job.customerSmartFlagProfileName)
      : null;
    const formatProfileName = (profile) => {
      if (
        customerDefaultId &&
        String(profile.id) === String(customerDefaultId)
      ) {
        return `${profile.name} (${translate("smart_flag_customer_default")})`;
      }

      return profile.name;
    };
    const directProfile = directProfileId
      ? profiles.find((profile) => String(profile.id) === String(directProfileId))
      : null;
    const selectedValue = job.smartFlagProfileDisabled
      ? SMART_FLAG_NONE
      : directProfileId
        ? directProfileId
        : customerDefaultId &&
            ["customer", "parentCustomer"].includes(
              job.effectiveSmartFlagProfileSource,
            )
          ? SMART_FLAG_CUSTOMER_DEFAULT
          : SMART_FLAG_NONE;
    const otherProfiles = profiles.filter(
      (profile) => !defaultProfileIds.includes(String(profile.id)),
    );

    return (
      <div className={classes.smartFlagProfileRow}>
        <Tooltip title={sourceMessage} disableTriggerFocus={true}>
          <Icon className={classes.smartFlagProfileIcon}>info_outline</Icon>
        </Tooltip>
        <Typography type="caption" className={classes.smartFlagProfileLabel}>
          <strong>{translate("job_smart_flag_profile")}</strong>:
        </Typography>
        <FormControl
          className={classes.smartFlagProfileSelectControl}
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <Select
            value={selectedValue}
            displayEmpty
            renderValue={(value) => {
              if (value === SMART_FLAG_NONE) {
                return translate("none_constant");
              }

              if (value === SMART_FLAG_CUSTOMER_DEFAULT) {
                return `${customerDefaultName} (${translate("smart_flag_customer_default")})`;
              }

              const selectedProfile =
                directProfile ||
                profiles.find(
                  (profile) => String(profile.id) === String(value),
                );

              return selectedProfile ? formatProfileName(selectedProfile) : profileName;
            }}
            onChange={(event) => {
              event.stopPropagation();
              if (onSmartFlagProfileChange) {
                onSmartFlagProfileChange(event.target.value);
              }
            }}
            input={
              <Input
                name="smartFlagProfileId"
                id={`job-${job.id}-smartFlagProfileId`}
                className={classes.smartFlagProfileSelectInput}
              />
            }
            className={classes.smartFlagProfileSelect}
            classes={{
              icon: classes.smartFlagProfileSelectIcon,
              select: classes.smartFlagProfileSelectDisplay,
            }}
            disabled={!onSmartFlagProfileChange}
            autoWidth
          >
            <MenuItem value={SMART_FLAG_NONE}>
              {translate("none_constant")}
            </MenuItem>
            {customerDefaultId && (
              <MenuItem value={SMART_FLAG_CUSTOMER_DEFAULT}>
                {customerDefaultName} ({translate("smart_flag_customer_default")})
              </MenuItem>
            )}
            {otherProfiles.map((profile) => (
              <MenuItem key={profile.id} value={profile.id}>
                {formatProfileName(profile)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <div className={classes.smartFlagProfileActions}>
          <Tooltip title={translate("tooltip_edit_smart_flag_profile")} disableTriggerFocus={true}>
            <span>
              <Button
                aria-label="Edit Smart Flag Profile"
                mini
                disabled={!hasEffectiveProfile}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  if (hasEffectiveProfile && onEditSmartFlagProfile) {
                    onEditSmartFlagProfile();
                  }
                }}
                className={`${classes.smartFlagProfileButton} ${
                  !hasEffectiveProfile
                    ? classes.smartFlagProfileButtonDisabled
                    : ""
                }`}
              >
                <Icon>edit</Icon>
              </Button>
            </span>
          </Tooltip>
        </div>
      </div>
    );
  }

  render() {
    const {
      translate,
      classes,
      job,
      edit,
      del,
      reportGen,
      attachments,
      view,
      jobReload,
      downloadCsv,
      rengernateImage,
      imageGenerationFailed,
      // selected,
      totalSelected,
      isSelectionShow,
      title,
      exportJob,
      downloadExportedJob,
      showSmartFlagProfileContext,
    } = this.props;

    let disableControlButtons = false;
    if (job && job.pendingcount) {
      disableControlButtons = true;
    }
    const isCometJob =
      job && job.deviceid
        ? ["comet_copper", "comet_fiber"].includes(job.deviceid)
        : false;
    const isMobileJob = job && isVDVType(job.deviceid);
    const isSignalTEKQtJob = job && isSignalTEKQTType(job.deviceid);
    const isNaviTEKJob = job && isNaviTEKType(job.deviceid);
    return (
      <Paper className={classes.paper}>
        <Grid container className={classes.removeMargin}>
          <Grid item xs={8} className={classes.jobsHeader}>
            <ButtonBase
              className={classes.jobHeaderDetails}
              component={Link}
              to={`/job/${job.id}`}
            >
              <Grid className={classes.jobHeaderDetails}>
                <Typography type="title">{job.name}</Typography>
                <Typography type="subheading" className={classes.jobDate}>
                  {dateFormatter(job.createdat)}
                </Typography>
                <div className={classes.innerjobDetails}>
                  <Typography type="subheading" className={classes.jobCustomer}>
                    {job.customer_name}
                  </Typography>
                  <Typography type="subheading" className={classes.jobDate}>
                    {isMobileJob
                      ? translate("vdviipoepro")
                      : isSignalTEKQtJob
                        ? translate("signaltekqtorpro")
                        : isNaviTEKJob
                          ? translate("navitekorpro")
                          : job.deviceid
                            ? translate(job.deviceid)
                            : translate("lantekIII")}
                  </Typography>
                </div>
              </Grid>
            </ButtonBase>

            {showSmartFlagProfileContext && this.renderSmartFlagProfile()}

            {view !== undefined && (
              <Grid item className={classes.jobFunctions}>
                {edit !== undefined && (
                  <Tooltip
                    title={translate("tooltip_edit")}
                    disableTriggerFocus={true}
                  >
                    <Button
                      aria-label="Edit"
                      mini
                      onClick={(e) => edit(e, job)}
                      id={job.id}
                      className={classes.jobcardButtons}
                      disabled={disableControlButtons}
                    >
                      <Icon color={"primary"}>edit</Icon>
                    </Button>
                  </Tooltip>
                )}
                {reportGen !== undefined && (
                  <Tooltip
                    title={translate("tooltip_create_report")}
                    disableTriggerFocus={true}
                  >
                    <Button
                      aria-label="Create Report"
                      mini
                      onClick={(e) => reportGen(e, job)}
                      id={job.id}
                      className={classes.jobcardButtons}
                      disabled={disableControlButtons}
                    >
                      <Icon color={"primary"}>insert_drive_file</Icon>
                    </Button>
                  </Tooltip>
                )}
                {attachments !== undefined && (
                  <Tooltip
                    title={translate("tooltip_attach_files")}
                    disableTriggerFocus={true}
                  >
                    <Button
                      aria-label="Attach Files"
                      mini
                      onClick={(e) => attachments(e, job)}
                      id={job.id}
                      className={`${classes.jobcardButtons} ${
                        job && job.attachmentexists
                          ? classes.attachmentExists
                          : ""
                      }`}
                      disabled={disableControlButtons}
                    >
                      <Icon>attach_file</Icon>
                    </Button>
                  </Tooltip>
                )}
                {del !== undefined && (
                  <Tooltip
                    title={translate("tooltip_delete")}
                    disableTriggerFocus={true}
                  >
                    <Button
                      aria-label="Delete"
                      mini
                      onClick={(e) => del(e, job)}
                      id={job.id}
                      className={classes.jobcardButtons}
                      disabled={disableControlButtons}
                    >
                      <Icon color={"primary"}>delete</Icon>
                    </Button>
                  </Tooltip>
                )}
                <Tooltip
                  title={translate("tooltip_download_csv")}
                  disableTriggerFocus={true}
                >
                  <Button
                    aria-label="Download"
                    mini
                    onClick={() => downloadCsv(job.id, job.name)}
                    id={job.id}
                    className={classes.jobcardButtons}
                    disabled={disableControlButtons}
                  >
                    <Icon color={"primary"}>
                      <img
                        height="18px"
                        width="18px"
                        src={"/images/labelroll.svg"}
                      />
                    </Icon>
                  </Button>
                </Tooltip>
                {((imageGenerationFailed &&
                  imageGenerationFailed.showImageReGenerate &&
                  imageGenerationFailed.imageFailedJobId === job.id) ||
                  job.imagefailed) && (
                  <Tooltip
                    title={translate("regenerate_image")}
                    disableTriggerFocus={true}
                  >
                    <Button
                      aria-label="REGENERATEIMAGE"
                      mini
                      onClick={() => rengernateImage(job.id)}
                      id={job.id}
                      className={classes.jobcardButtons}
                    >
                      <Icon color={"primary"}>image</Icon>
                    </Button>
                  </Tooltip>
                )}
                {job.deviceid && !isMobileJob ? (
                  <Tooltip
                    title={
                      disableControlButtons
                        ? ""
                        : job.enablesync
                          ? translate("job_disablesync")
                          : translate("job_enablesync")
                    }
                    disableTriggerFocus={true}
                  >
                    <FormGroup className={classes.syncButton}>
                      <FormControlLabel
                        control={
                          <Switch
                            name="enablesync"
                            checked={job.enablesync}
                            onChange={(e, checked) =>
                              this.onToggleChange(e, checked, job)
                            }
                            disabled={disableControlButtons}
                            classes={{
                              root: classes.toggle,
                              bar: classes.toggleBar,
                              checked: classes.toggleOn,
                            }}
                          />
                        }
                      />
                    </FormGroup>
                  </Tooltip>
                ) : null}

                {isCometJob ? (
                  !(
                    ["in_progress"].includes(job.exportstatus) ||
                    disableControlButtons
                  ) ? (
                    <Tooltip
                      title={
                        disableControlButtons
                          ? ""
                          : job.exportstatus == "failed"
                            ? translate("tooltip_export_job_failed")
                            : job.exportstatus == "in_progress"
                              ? translate("tooltip_export_job_in_progress")
                              : translate("export_job")
                      }
                      disableTriggerFocus={true}
                    >
                      <Button
                        aria-label="EXPORTJOB"
                        mini
                        onClick={(e) => exportJob(e, job, "export")}
                        id={job.id}
                        className={classes.jobcardButtons}
                      >
                        <Icon color={"primary"}>import_export</Icon>
                      </Button>
                    </Tooltip>
                  ) : (
                    <Tooltip
                      title={
                        disableControlButtons
                          ? ""
                          : job.exportstatus == "failed"
                            ? translate("tooltip_export_job_failed")
                            : job.exportstatus == "in_progress"
                              ? translate("tooltip_export_job_in_progress")
                              : translate("export_job")
                      }
                      disableTriggerFocus={true}
                    >
                      <span className={classes.exportIcon}>
                        <Button
                          aria-label="EXPORTJOB"
                          mini
                          onClick={(e) => exportJob(e, job, "export")}
                          id={job.id}
                          className={classes.jobcardButtons}
                          disabled={
                            ["in_progress"].includes(job.exportstatus) ||
                            disableControlButtons
                          }
                        >
                          {job.exportstatus == "in_progress" ? (
                            <CircularProgress
                              className={classes.exportProgress}
                              size={20}
                              thickness={4}
                            />
                          ) : (
                            <Icon color={"primary"}>import_export</Icon>
                          )}
                        </Button>
                      </span>
                    </Tooltip>
                  )
                ) : null}

                {isCometJob && job.exported ? (
                  !(
                    ["failed", "in_progress"].includes(job.exportstatus) ||
                    disableControlButtons
                  ) ? (
                    <Tooltip
                      title={
                        disableControlButtons ||
                        ["failed", "in_progress"].includes(job.exportstatus)
                          ? ""
                          : translate("download_job")
                      }
                      disableTriggerFocus={true}
                    >
                      <Button
                        aria-label="DOWNLOADEXPORTJOB"
                        mini
                        onClick={(e) => downloadExportedJob(e, job, "download")}
                        id={job.id}
                        className={classes.jobcardButtons}
                      >
                        <Icon color={"primary"}>file_download</Icon>
                      </Button>
                    </Tooltip>
                  ) : (
                    <Tooltip
                      title={
                        disableControlButtons ||
                        ["failed", "in_progress"].includes(job.exportstatus)
                          ? ""
                          : translate("download_job")
                      }
                      disableTriggerFocus={true}
                    >
                      <span className={classes.exportIcon}>
                        <Button
                          aria-label="DOWNLOADEXPORTJOB"
                          mini
                          onClick={(e) =>
                            downloadExportedJob(e, job, "download")
                          }
                          id={job.id}
                          className={classes.jobcardButtons}
                          disabled={
                            ["failed", "in_progress"].includes(
                              job.exportstatus,
                            ) || disableControlButtons
                          }
                        >
                          <Icon color={"primary"}>file_download</Icon>
                        </Button>
                      </span>
                    </Tooltip>
                  )
                ) : null}
              </Grid>
            )}
          </Grid>
          <Grid item xs={4} className={classes.jobCardRight}>
            <ButtonBase
              className={classes.buttonBase}
              component={Link}
              to={`/job/${job.id}`}
            >
              <Grid item xs={12}>
                <Grid
                  container
                  direction="row"
                  justify="flex-start"
                  alignItems="center"
                  className={classes.jobTotals}
                >
                  <Grid item xs={4} md={3} className={classes.totalGrid}>
                    <Typography
                      type="body1"
                      className={classes.totalText}
                      align="center"
                    >
                      {translate("job_header_total")}
                    </Typography>
                    <Typography
                      type="display1"
                      className={classes.totalText}
                      align="center"
                      gutterBottom
                    >
                      {job.totaltest}
                    </Typography>
                  </Grid>
                  <Grid item xs={4} md={3} className={classes.passedGrid}>
                    <Typography
                      type="body1"
                      className={classes.passedText}
                      align="center"
                    >
                      {translate("job_header_passed")}
                    </Typography>
                    <Typography
                      type="display1"
                      className={classes.passedText}
                      align="center"
                      gutterBottom
                    >
                      {job.passedtest}
                    </Typography>
                  </Grid>
                  <Grid item xs={4} md={3} className={classes.failedGrid}>
                    <Typography
                      type="body1"
                      className={classes.failedText}
                      align="center"
                    >
                      {translate("job_header_failed")}
                    </Typography>
                    <Typography
                      type="display1"
                      className={classes.failedText}
                      align="center"
                      gutterBottom
                    >
                      {job.failedtest}
                    </Typography>
                  </Grid>
                  {isSelectionShow && (
                    <Grid item xs={4} md={3} className={classes.selectedGrid}>
                      <Typography
                        type="body1"
                        className={classes.passedText}
                        align="center"
                      >
                        {translate("job_header_selected")}
                      </Typography>
                      <Typography
                        type="display1"
                        className={classes.passedText}
                        align="center"
                        gutterBottom
                      >
                        {totalSelected}
                      </Typography>
                    </Grid>
                  )}
                </Grid>

                <Grid container>
                  <Grid item xs={12} className={classes.progressBar}>
                    <JobProgress
                      total={job.totaltest}
                      pass={job.passedtest}
                      fail={job.failedtest}
                    />
                  </Grid>
                </Grid>
              </Grid>
              {view !== undefined && (
                <Button className={classes.viewJob} color="accent" raised mini>
                  {translate ? translate("general_view") : "View"}
                </Button>
              )}
            </ButtonBase>
            {disableControlButtons && (
              <span>
                <span className={classes.jobStatus}>
                  {`${translate("uploaded_tests_pending_process_count")}: ${
                    job.pendingcount
                  }`}
                </span>
                {title && title == "jobspage" && (
                  <Tooltip
                    title={translate("tooltip_reload")}
                    disableTriggerFocus={true}
                  >
                    <Button
                      aria-label="Reload"
                      mini
                      onClick={() => jobReload(job.id)}
                      id={job.id}
                      className={classes.reloadButton}
                    >
                      <Icon color={"primary"}>refresh</Icon>
                    </Button>
                  </Tooltip>
                )}
              </span>
            )}
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

export default withStyles(styles)(JobHeader);
